const store = app.store;
export default (type, redirect) => {
    return new Promise(async (resolve, reject) => {
        if (store.getters['rms_ui/auth/auth_loading']()) {
            //waiting for store to be initialized...;
            const watcher = store.watch(store.getters['rms_ui/auth/auth_loading'], async (val) => {
                watcher(); // stop watching
                let isPrimary = app.auth.user.isPrimaryCampaign();
                if (isPrimary && type === 'primary') {
                    resolve(true);
                } else if (!isPrimary && type !== 'primary') {
                    reolve(true);
                } else {
                    reject({path: redirect});
                }
            });
        } else {
            let isPrimary = app.auth.user.isPrimaryCampaign();
            if (isPrimary && type === 'primary') {
                resolve(true);
            } else if (!isPrimary && type !== 'primary') {
                reolve(true);
            } else {
                reject({path: redirect});
            }
        }
    })
}
